import _ from 'lodash'
import { useSlideStore } from '~/store/slide'
import { useWishStore } from '~/store/wish'
import { usePreweddingStore } from '~/store/prewedding'

export const useSlideModeA = () => {
  const slideStore = useSlideStore()
  const wishStore = useWishStore()
  const preweddingStore = usePreweddingStore()

  function main() {
    slideStore.index++
    watchIndexAndViewMode();
    slideStore.restore_Previous_View_And_Save_If_New_Wish_Avaliable();

    let newWishList = wishStore.getNewDocIdList()
    let currentView = newWishList.length > 0 ? 'new_wish' : slideStore.view
    slideStore.showNewWishIcon = false

    // when empty wishes
    if(wishStore.all?.length === 0) {
      return {
        type: 'prewedding',
        data: preweddingStore.queue.shift()
      }
    }
    // ------------------

    switch (currentView) {
      case 'prewedding':
        return {
          type: 'prewedding',
          data: preweddingStore.queue.shift()
        }

      case 'wish':
        slideStore.checkNextSlide() 
        const docId = wishStore.queue.shift()
        const wishData = wishStore.getWishDataById(docId)
        return {
          type: 'wish',
          data: wishData
        }

      case 'new_wish':
        slideStore.showNewWishIcon = true

        const newWishId = newWishList[0]
        const newWishData = wishStore.getWishDataById(newWishId)
        wishStore.newWishes.shift();

        return {
          type: 'wish',
          data: newWishData,
        }

      default:
        break;
    }
  }


  function watchIndexAndViewMode() {

    // toggle view mode 
    let newVal = slideStore.index

    if (slideStore.view == 'prewedding' && newVal >= slideStore.limit) {
      slideStore.view = 'wish'
      slideStore.index = 0
    } else if (slideStore.view == 'wish' && newVal >= slideStore.limit) {
      slideStore.view = 'prewedding'
      slideStore.index = 0
    }

    slideStore.limit = slideStore.itemLimit
  }


  return {
    main,
  }

}